import { createBrowserRouter, RouterProvider, } from "react-router-dom";
import Invoicing from "./pages";

export const router = createBrowserRouter([
    {
        path: '/:invoiceId',
        element: <Invoicing />,
    },
    {
        path: '*',
        element: <div>404</div>,
    },
]);

function Routes() {
    return (
        <RouterProvider router={router} />
    );
}

export default Routes;
